module.exports = __webpack_public_path__ + "static/img/10.6bf1919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10.png
// module id = 188
// module chunks = 1